import HiggsPromise from '../../utils/higgsPromise';

/* 财务画像-首页-根据公司code获取相关下拉选项的数据
 * GET请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
*/
export function getOptions(data) {
    return HiggsPromise({
        url: '/index/code',
        data: data,
        transformResponse: function (data) {
            if(data.data && data.data.endDate) {
                let endDate = data.data.endDate;
                endDate.forEach((d, i) => endDate[i] = `${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6)}`);
            }
            return data;
        }
    });
}



// WEBPACK FOOTER //
// ./src/services/financialPicture/index.js